import React from 'react'
import { BrowserRouter } from "react-router-dom";
import TaskManager from "./component/TaskFolder"
export const App = () => {
  return <>
    <BrowserRouter>
      <TaskManager />
    </BrowserRouter>
  </>
}

export default App;